'use strict';

;(function () {
  let addToCartBtn;

  function checkSafetyStock() {
    let selectedVariantId, selectedVariant, pdpSimlpeContainer;
    
    pdpSimlpeContainer = document.querySelector('.pdp-simple');

    if (!pdpSimlpeContainer) {
      return;
    }

    const ADD_TO_CART_T = pdpSimlpeContainer.dataset.addToCartT;
    const PRE_ORDER_T = pdpSimlpeContainer.dataset.preorderT;
    const SOLD_OUT_T = pdpSimlpeContainer.dataset.soldOutT;

    // Validation only for members
    if(!addToCartBtn){
      return;
    }
    
    selectedVariantId = getSelectedVariantId();
    selectedVariant = window.EBSDataLayer.product.variants.find((v) => { return v.id == selectedVariantId });

    let inStock = true;

    //If the variant has a set Safety Stock, check quantity against that, otherwise, check against product level safety stock levels
    if (selectedVariant.inventoryManagement) {
      if (selectedVariant.safetyStockLevel > 0) {
        if(selectedVariant.inventoryQuantity <= selectedVariant.safetyStockLevel){
          inStock = false;
        } 
      } else {
        if(selectedVariant.inventoryQuantity <= window.EBSDataLayer.product.safetyStockLevel){
          inStock = false;
        }
      }
    }
       
    if (!inStock) {
      addToCartBtn.innerText = SOLD_OUT_T;
      addToCartBtn.setAttribute('disabled', true);
    } else {
      addToCartBtn.innerText = selectedVariant.isPreorder ? PRE_ORDER_T : ADD_TO_CART_T;
      addToCartBtn.removeAttribute('disabled');
    }
  }

  function getSelectedVariantId(){
    return document.querySelector('[name="id"]:checked').value;
  }
  
  function onDocumentLoaded(){
    addToCartBtn = document.querySelector('.pdp-buttons .add-to-cart');

    document.querySelectorAll('[name="id"]').forEach((variantRadioBtn) => {
      variantRadioBtn.addEventListener('change', selectedVariantRadioChanged);
    });

    checkSafetyStock();
  }

  function selectedVariantRadioChanged(e){
    if(e.currentTarget.checked){
      checkSafetyStock();
    }
  }
  
  if(document.readyState != 'loading'){
    onDocumentLoaded();
  } else {
    document.addEventListener("DOMContentLoaded", onDocumentLoaded);
  }
})();